import React from 'react';
import { Box } from '@mui/material';

const PickingStatusDot = ({ status, size = 14 }) => {
  const borderW = size >= 28 ? 3 : 2;

  if (status === 'orphan') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: '#d32f2f',
        }}
      />
    );
  }
  if (status === 'full') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: '#2e7d32',
        }}
      />
    );
  }
  if (status === 'partial') {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: '#fff59d',
          border: '1px solid rgba(0,0,0,0.12)',
        }}
      />
    );
  }
  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '50%',
        border: `${borderW}px solid #bdbdbd`,
        bgcolor: 'transparent',
        boxSizing: 'border-box',
      }}
    />
  );
};

export default PickingStatusDot;
